import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { InfoIconTooltipStyles } from "@tCentro/Overrides/Components/ProductAddToCartButton";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState, ownProps: HasProduct) => ({
    configurationSelection: state.pages.productDetails.configurationSelection,
    configurationCompleted: state.pages.productDetails.configurationCompleted,
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
    subscription: state.pages.productDetails.subscription,
});

export interface ProductDetailsAddToCartButtonStyles {
    button?: ButtonPresentationProps & InfoIconTooltipStyles;
}

export const addToCartButtonStyles: ProductDetailsAddToCartButtonStyles = {
    button: {
        css: css`
            width: 100%;
            border-radius: 24px !important;
            width: 176px !important;
            height: 48px !important;
            white-space: nowrap;
            display: flex;
            flex-direction: column;
            justify-content: center;
            &:disabled {
                background: ${getColor("secondary")};
                border-color: ${getColor("secondary")};
                opacity: 0.5;
            }
            > span {
                font-size: ${TYPOGRAPHY.size.large};
                font-family: ${TYPOGRAPHY.fontFamily.base};
                line-height: ${TYPOGRAPHY.lineHeight.base};
                text-align: center;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-size: ${TYPOGRAPHY.size.smaller};
                        `,
                        null,
                        null,
                        null,
                        null,
                    ])}
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: max-content !important;
                        `,
                        css`
                            margin-top: 16px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
            )}
            @media (min-width: 992px) and (max-width: 1180px) {
                    width: 240px !important;
            }
            @media (max-width: 991px){
                width: 220px !important; 
            }
             @media (max-width: 767px){
                margin-top: 0px;
             }
             @media (max-width: 420px){
                width: 180px !important; 
             }
        `,

        hiddenMobileToolTip: {
            css: css`
                display: inline;
                position: relative;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            left: 35px;
                            top: 12px;
                            position: absolute;
                        `,
                        css`
                            left: 35px;
                            top: 28px;
                            position: absolute;
                        `,
                        css`
                            left: 10%;
                            top: 12px;
                            position: absolute;
                        `,
                        css`
                            @media (min-width: 992px) and (max-width: 1024px) {
                                top: 12px;
                                left: 20%;
                                position: absolute;
                            }
                        `,
                        null,
                    ])}
                    @media (max-width: 420px){
                        left: 10px; 
                    }
            `,
        },
        mobileTooltip: {
            cssOverrides: {
                tooltipBody: css`
                    left: 0px;
                `,
            },
        },
        tooltipButtonContainer: {
            css: css`
                display: flex;
                position: relative;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            flex-direction: column-reverse;
                            align-items: flex-start !important;
                            margin-top: 0px;
                        `,
                        css`
                            flex-direction: column-reverse;
                            align-items: flex-start !important;
                            margin-top: 0px;
                        `,
                        css`
                            flex-direction: column-reverse;
                            align-items: flex-start !important;
                        `,
                        null,
                        null,
                    ])}
            `,
        },
    },
};

const styles = addToCartButtonStyles;

const ProductDetailsAddToCartButton = ({
    configurationSelection,
    configurationCompleted,
    variantSelectionCompleted,
    subscription,
}: Props) => {
    return (
        <ProductAddToCartButton
            configurationSelection={configurationSelection}
            configurationCompleted={configurationCompleted}
            variantSelectionCompleted={variantSelectionCompleted}
            subscription={subscription}
            extendedStyles={styles.button}
            data-test-selector="addProductToCart"
        />
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(connect(mapStateToProps)(ProductDetailsAddToCartButton)),
    definition: {
        displayName: "Add to Cart Button",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
